import '../sass/text-and-media-columns.scss';

(() => {
    const $blocks = document.querySelectorAll('.text-and-media-columns');

    $blocks?.forEach($block => {
        const $videoModal = $block.querySelector('.text-and-media-columns__video-modal');
        const $videoContainer = $block.querySelector('.text-and-media-columns__video-container');
        const $videoPlayer = $block.querySelector('.text-and-media-columns__video-player');
        const $video = $block.querySelector('.text-and-media-columns__video');

        const initVideoModal = () => {
            if (!$videoModal || !$video) return;

            const player = new Plyr($video);

            $videoModal.addEventListener('modalopen', () => {
                player.play();
            });

            $videoModal.addEventListener('modalafterclose', () => {
                player.pause();
            });

            updateVideoSize();
        };

        const updateVideoSize = () => {
            if (!$videoContainer || !$videoPlayer) return;

            const containerMultiplier = $videoContainer.offsetWidth / $videoContainer.offsetHeight;
            const multiplier = $videoPlayer.dataset.videoWidth / $videoPlayer.dataset.videoHeight;

            if (containerMultiplier > multiplier) {
                $videoPlayer.style.width = 'auto';
                $videoPlayer.style.height = `${$videoContainer.offsetHeight}px`;
            } else {
                $videoPlayer.style.width = `${$videoContainer.offsetWidth}px`;
                $videoPlayer.style.height = 'auto';
            }
        };

        window.addEventListener('resize', () => {
            updateVideoSize();
        });

        initVideoModal();
    });
})();
